import { useEffect, useRef, useState } from "react";
import Edge from "./Edge";
import RightPanel from "./RightPanel";
import Node from "./Node";
import { webUrlNode } from "../../../../constants/appInfo";
import CreateCanvasStepForm from "./CreateCanvasStepForm";
import PannableCanvas from "./PannableCanvas";
import StepNode from "./StepNode";

export default function FunnelCanvas() {

  const [steps, setSteps] = useState([]);
  const [links, setLinks] = useState([]);
  const [selectedStep, setSelectedStep] = useState(null);
  const [stepTemplate, setStepTemplate] = useState(null);
const [linkingFrom, setLinkingFrom] = useState(null);   // step
const [mousePos, setMousePos] = useState(null);        // {x,y}
const [hoverStepId, setHoverStepId] = useState(null);  // target highlight
const canvasRef = useRef(null);
    const [linkingActionKey, setLinkingActionKey] = useState("start_trial");
  useEffect(() => {
    loadCanvas();
  }, []);

  useEffect(() => {

  if (!linkingFrom) return;

  function onMove(e) {

    const canvas = canvasRef.current;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();

    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  }

  window.addEventListener("mousemove", onMove);

  return () => {
    window.removeEventListener("mousemove", onMove);
  };

}, [linkingFrom]);
useEffect(() => {

  if (!selectedStep?.templateId) return;

  fetch(`${webUrlNode}/api/email/templates`)
    .then(r => r.json())
    .then(list => {

      const t = list.find(
        x => x.id === selectedStep.templateId
      );

      if (!t) return;

      setStepTemplate(t);
    });

}, [selectedStep]);
  async function loadCanvas() {

    const res = await fetch(`${webUrlNode}/api/funnels/canvas/35`);
    const data = await res.json();
console.log(data)
    setSteps(data.steps);
    setLinks(data.links);
  }

  
  function updateLocalPosition(id, x, y) {

  setSteps(prev =>
    prev.map(s =>
      s.id === id ? { ...s, x, y } : s
    )
  );
}

async function savePosition(id, x, y) {

  await fetch(`${webUrlNode}/api/funnels/steps/${id}/position`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ x, y })
  });
}
  return (<>
    <div  style={{ display: "flex", height: "90vh",marginTop:"70px" }}>
<CreateCanvasStepForm
xCord={steps?.length}
  onCreated={(step) => {
    setSteps(prev => [...prev, step]);
  }}
/>
<PannableCanvas>
  <div ref={canvasRef}
  style={{ position: "relative", width: 3000, height: 3000 }}
 onMouseDown={(e) => {

    // click on empty canvas only
    if (e.target == e.currentTarget) return;

    setLinkingFrom(null);
    setMousePos(null);
    setHoverStepId(null);
  }}
>
     <div style={{ position: "relative", width: "100%", height: "100%" }}>

        <svg
          width="100%"
          height="100%"
          style={{
    position: "absolute",
    overflow: "visible",     // ✅ IMPORTANT
    pointerEvents: "none"
  }}
        >    
        <defs>
  <marker
    id="link-arrow"
    viewBox="0 0 10 10"
    refX="10"
    refY="5"
    markerWidth="6"
    markerHeight="6"
    orient="auto"
  >
    <path d="M 0 0 L 10 5 L 0 10 z" fill="#2563eb" />
  </marker>
</defs>
        {linkingFrom && mousePos && (() => {

  const x1 = linkingFrom.x+100;
  const y1 = linkingFrom.y+30;
  const x2 = mousePos.x;
  const y2 = mousePos.y;

  // horizontal first, then vertical
  const midX = x1 + (x2 - x1) * 0.5;
const midX1 = x1 + (x2 - x1) * 0.1;
const midX2 = x1 + (x2 - x1) * 0.2;
const midX3 = x1 + (x2 - x1) * 0.3;
const midX4 = x1 + (x2 - x1) * 0.4;
const midX5 = x1 + (x2 - x1) * 0.5;
const midX6 = x1 + (x2 - x1) * 0.6;
const midX7 = x1 + (x2 - x1) * 0.7;
const midX8 = x1 + (x2 - x1) * 0.8;
const midX9 = x1 + (x2 - x1) * 0.9;
const midX10 = x1 + (x2 - x1) * 0.10;
const midX11 = x1 + (x2 - x1) * 0.11;
const midX12 = x1 + (x2 - x1) * 0.12;
const midX13 = x1 + (x2 - x1) * 0.13;
const midX14 = x1 + (x2 - x1) * 0.14;
const midX15 = x1 + (x2 - x1) * 0.15;
const midX16 = x1 + (x2 - x1) * 0.16;
const midX17 = x1 + (x2 - x1) * 0.17;
const midX18 = x1 + (x2 - x1) * 0.18;
const midX19 = x1 + (x2 - x1) * 0.19;
const midX20 = x1 + (x2 - x1) * 0.20;
const midX21 = x1 + (x2 - x1) * 0.21;
const midX22 = x1 + (x2 - x1) * 0.22;
const midX23 = x1 + (x2 - x1) * 0.23;
const midX24 = x1 + (x2 - x1) * 0.24;
const midX25 = x1 + (x2 - x1) * 0.25;
const midX26 = x1 + (x2 - x1) * 0.26;
const midX27 = x1 + (x2 - x1) * 0.27;
const midX28 = x1 + (x2 - x1) * 0.28;
const midX29 = x1 + (x2 - x1) * 0.29;
const midX30 = x1 + (x2 - x1) * 0.30;

const midX31 = x1 + (x2 - x1) * 0.31;
const midX32 = x1 + (x2 - x1) * 0.32;
const midX33 = x1 + (x2 - x1) * 0.33;
const midX34 = x1 + (x2 - x1) * 0.34;
const midX35 = x1 + (x2 - x1) * 0.35;
const midX36 = x1 + (x2 - x1) * 0.36;
const midX37 = x1 + (x2 - x1) * 0.37;
const midX38 = x1 + (x2 - x1) * 0.38;
const midX39 = x1 + (x2 - x1) * 0.39;
const midX40 = x1 + (x2 - x1) * 0.40;
  const d = `
    M ${x1} ${y1}
     L ${midX1} ${y2}
    L ${midX2} ${y2}
    L ${midX3} ${y2}
    L ${midX4} ${y2}
    L ${midX5} ${y2}
    L ${midX6} ${y2}
    L ${midX7} ${y2}
    L ${midX8} ${y2}
    L ${midX9} ${y2}
    L ${midX10} ${y2}
    
    L ${midX11} ${y2}
    L ${midX12} ${y2}
    L ${midX13} ${y2}
    L ${midX14} ${y2}
    L ${midX15} ${y2}
    L ${midX16} ${y2}
    L ${midX17} ${y2}
    L ${midX18} ${y2}
    L ${midX19} ${y2}
    
    L ${midX21} ${y2}
    L ${midX22} ${y2}
    L ${midX23} ${y2}
    L ${midX24} ${y2}
    L ${midX25} ${y2}
    L ${midX26} ${y2}
    L ${midX27} ${y2}
    L ${midX28} ${y2}
    L ${midX29} ${y2}
    L ${midX30} ${y2} 

    
    L ${midX31} ${y2}
    L ${midX32} ${y2}
    L ${midX33} ${y2}
    L ${midX34} ${y2}
    L ${midX35} ${y2}
    L ${midX36} ${y2}
    L ${midX37} ${y2}
    L ${midX38} ${y2}
    L ${midX39} ${y2}
    L ${midX40} ${y2} 
    
    
    L ${x2} ${y2}
  `;

  return (
   <path
  d={d}
  fill="none"
  stroke="#2563eb"
  strokeDasharray="5,5"
  strokeWidth="2"
  markerEnd="url(#link-arrow)"
/>
  );
})()}
          {links?.length?links.map(l => (<>
   
            <Edge key={l.id} link={l} steps={steps?.length?steps:[]} />
        </>  )):""}
        </svg>

        {steps?.length?steps?.map(s => (<>
         <StepNode
  key={s.id}
  step={s}   selected={selectedStep?.id === s.id}
           
  onPositionChange={updateLocalPosition}
  onPositionCommit={savePosition}
  onSelect={(v)=>{setSelectedStep(v);}}
  linkingFrom={linkingFrom}
  mousePos={mousePos}
  hoverStepId={hoverStepId}reloadLinks={()=>{loadCanvas()}}
   setLinkingFrom= {setLinkingFrom}  // step
setMousePos = {setMousePos}       // {x,y}
 setHoverStepId = {setHoverStepId}  // target highlight
onStartLink={(payload) => {

  const rect = canvasRef.current.getBoundingClientRect();

  setLinkingFrom({
    step: payload.step,
    actionKey: payload.actionKey,
    x: payload.x - rect.left,
    y: payload.y - rect.top
  });

  setLinkingActionKey(payload.actionKey);
}}
  onHoverTarget={(hovering) =>
    setHoverStepId(hovering ? s.id : null)
  }  stepTemplate={stepTemplate} setStepTemplate={(v)=>{setStepTemplate(v)}}
 
  actionKey={linkingActionKey}
/></>
        )):""}

      </div></div>
</PannableCanvas>
<div >
<RightPanel
        step={selectedStep}
        steps={steps}
        onLinkCreated={(l) => setLinks([...links, l])}
        
      />
</div>
      

    </div>
    </>
  );
}
